import classNames from 'classnames'
import React from 'react'
import {useWidgetState} from '../../../hooks/state-provider'
import {getAlignmentClassName} from '../../../selectors/classes'
import {getComponentConfig} from '../../../selectors/settings'
import {getAlignment, isOnImageLayout} from '../../../selectors/single-settings'
import s from './divider.scss'
import {DividerProps} from './interfaces'

export const Divider = ({width, height}: DividerProps) => {
  const alignmentClassName = useWidgetState(state => getAlignmentClassName(getAlignment(getComponentConfig(state))))
  const onImage = useWidgetState(isOnImageLayout)

  return (
    <div
      className={classNames(s[alignmentClassName], onImage ? s.onImage : s.offImage)}
      data-hook="divider"
      style={{width, height}}
    />
  )
}
